import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetRequestList } from '../../../store/Ame/ameRequestSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { Card, CardBody, CardExpandToggler, CardHeader } from '../../../components/card/card';
import NtxTable from '../../../components/DataTable/NtxTable';
import Loading from '../../../components/Shared/Loader/Loading';

const RequestList = () => {
  const { t, i18n } = useTranslation();

  const Navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (RequestList?.length === 0) {
      dispatch(GetRequestList());
    }
  }, []);
  const { RequestList, loading, error } = useAppSelector(state => state.AmeRequest);

  const columns = [
    { title: t('Request'), key: 'Name' },
    { title: t('Applicant'), key: 'applicant' },
    { title: t('RequestDate'), key: 'date' },
    { title: t('RequestStatus'), key: 'status' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData =
    RequestList &&
    RequestList?.map((item: any) => {
      let rowClass;

      return {
        Name: i18n.language === 'ar' ? item.requestName2 : item.requestName,
        applicant: i18n.language === 'ar' ? item.personName2 : item.personName,
        date: item.dateCreated,
        status:
          item.status === 'IN PROGRESS' ? (
            <span className='badge text-theme fw-bold px-4 rounded fs-12px d-inline-flex align-items-center'>
              <i className='bi bi-clock-history fs-18px fa-fw me-5px'></i>
            </span>
          ) : item.status === 'QUESTION' ? (
            <span className='badge border   border-indigo text-indigo fw-bold px-5  rounded fs-12px d-inline-flex align-items-center'>
              <i className='bi bi-question-circle-fill fs-18px fa-fw me-5px'></i>
              {t('QUESTION')}
            </span>
          ) : (
            <span className='badge d-block rounded-0 pt-5px w-70px bg-white bg-opacity-25'>..</span>
          ),
        action: (
          <>
            <Link
              to={''}
              className='text-decoration-none text-inverse'
              onClick={() => Navigate(`/Ame/SelfService/Requests/${item.transectionHistoryId}/ViewRequests`)}
            >
              <i className='bi bi-eye-fill fs-5 text-theme'></i>
            </Link>
          </>
        ),

        rowClass // استخدم rowClass هنا
      };
    });

  return (
    <Card className=' mb-4 shadow-sm hover-userdashboard h-100'>
      <CardHeader>
        <div className='d-flex fw-bold small  align-items-center '>
          <i className='bi bi-clock-history fa-2x me-2 text-warning'></i>
          <span className='flex-grow-1  '>{t('RequestsInProgress')}</span>
          <CardExpandToggler />
        </div>
      </CardHeader>
      <CardBody>
        <Loading loading={loading} error={error} Type='Dots'>
          <NtxTable
            data={tableData || []}
            columns={columns}
            dataPerPage={5}
            theadClass=''
            tableClass='table text-nowrap table-hover '
          />
        </Loading>
      </CardBody>
    </Card>
  );
};

 

export default RequestList;

// <>
// {loading ? (
//   <div className="text-center ">
//     <div className="spinner-grow text-success"></div>
//     <div className="spinner-grow text-danger"></div>
//     <div className="spinner-grow text-warning"></div>
//   </div>
// ) : (
//   <>
//     {data && data?.length === 0 ? (
//       <NoData message=" لا يوجد لديك طلبات" />
//     ) : (
//       <>
//         <div className="table-responsive rounded-2 mb-2">
//           <table className="table mb-2px small text-nowrap rounded-2 text-center">
//             <thead className="bg-theme bg-opacity-60">
//               <tr>
//                 <th className=" fw-800 fs-6">الطلب</th>
//                 <th className=" fw-800 fs-6">مقدم الطلب</th>
//                 <th className=" fw-800 fs-6">تاريخ الطلب</th>
//                 <th className=" fw-800 fs-6">حالة الطلب</th>
//                 <th className=" fw-800 fs-6"></th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData &&
//                 currentData?.map((item: any, index) => (
//                   <tr key={item.transectionHistoryId}>
//                     <td className="align-middle">
//                       {i18n.language === 'ar' ? item.requestName2 : item.requestName}
//                     </td>
//                     <td className="align-middle">
//                       {i18n.language === 'ar' ? item.personName2 : item.personName}
//                     </td>
//                     <td className="align-middle">{item.dateCreated}</td>
//                     <td className="align-middle ">
//                       {item.status === 'IN PROGRESS' ? (
//                         <span className="badge text-theme fw-bold px-4 rounded fs-12px d-inline-flex align-items-center">
//                           <i className="bi bi-clock-history fs-18px fa-fw me-5px"></i>
//                         </span>
//                       ) : item.status === 'QUESTION' ? (
//                         <span className="badge border   border-indigo text-indigo fw-bold px-5  rounded fs-12px d-inline-flex align-items-center">
//                           <i className="bi bi-question-circle-fill fs-18px fa-fw me-5px"></i>
//                           {t('QUESTION')}
//                         </span>
//                       ) : (
//                         <span className="badge d-block rounded-0 pt-5px w-70px bg-white bg-opacity-25">
//                           ..
//                         </span>
//                       )}
//                     </td>
//                     <td>
//                       <Link
//                         to={''}
//                         className="text-decoration-none text-inverse"
//                         onClick={() =>
//                           Navigate(
//                             `/Ame/SelfService/Requests/${item.transectionHistoryId}/ViewRequests`
//                           )
//                         }>
//                         <i className="bi bi-eye-fill fs-5 text-theme"></i>
//                       </Link>
//                     </td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>
//         </div>
//         <Pagination
//           filteredData={data}
//           dataPerPage={dataPerPage}
//           handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
//           currentPage={currentPage}
//         />
//       </>
//     )}
//   </>
// )}
// </>
